import { render, staticRenderFns } from "./ChoosePassengerMulti.vue?vue&type=template&id=b9e8caf8&scoped=true"
import script from "./ChoosePassengerMulti.vue?vue&type=script&lang=js"
export * from "./ChoosePassengerMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e8caf8",
  null
  
)

export default component.exports